import { Badge } from '@/components/base/badge'
import { Divider } from '@/components/base/divider'
import { BeatLoader } from 'react-spinners'

interface Props {
  title: string
  value: string | number
  change: number
  timespan: string
  loading: boolean
}

export const Stat = ({ title, value, change, timespan, loading }: Props) => {
  const color = change > 0 ? 'green' : (change < 0 ? 'red' : 'blue')

  return (
    <>
      <div>
        <Divider />
        <div className="mt-6 text-lg/6 font-medium sm:text-base/6">{ title }</div>
        <div className="mt-3 text-4xl/8 font-semibold sm:text-3xl/8">
          { loading ? <BeatLoader color="lightgray" size={24} /> : value }
        </div>
        <div className="mt-3 text-base/6 sm:text-sm/6 flex flex-row items-center gap-2">
          <span><Badge color={color}>{ change > 0 ? '+' : '' }{ change }</Badge></span>
          <span className="text-zinc-500">from previous {timespan}</span>
        </div>
      </div>
    </>
  )
}
